export const MODULE_PREFIX = 'security-audit';
